export const groupNameTooltip: string = `<span>Enter up to 250 alphanumeric characters.</span>`;
